"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HandlerRole;
(function (HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole = exports.HandlerRole || (exports.HandlerRole = {}));



//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/cjs/interfaces.js
// module id = 355
// module chunks = 0